/* eslint-disable no-param-reassign */
import { PayloadAction } from '@reduxjs/toolkit';
import {
  State, CurrentState, Item,
} from '../menu-list.slice';

export default function setAvailable(state: State, action: PayloadAction<Item[]>): void {
  state.selected = [];
  state.available = action.payload;
  state.current = state.available.length > 0
    ? CurrentState.selecting
    : CurrentState.nothingAvailable;
}
